import React, { useState, useEffect } from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import Error from '../Shared/Error.js'
import ItemDetailsPane from './ItemDetailsPane.js'
import LoadingSpinnerImage from '../Shared/LoadingSpinnerImage.js'


const RelationProductsComplianceRegulations = ({ productId, productFamilyId, showTitleAsSubTitle = false }) => {

    const [isLoadingStructure, setIsLoadingStructure] = useState(true);
    const [errorLoadingStructure, setErrorLoadingStructure] = useState(false);
    const [dataTableStructure, setDataTableStructure] = useState({});

    const isProductFamily = productFamilyId != null && productFamilyId !== undefined;

    let config = {};

    config.dataUrl = isProductFamily
        ? "/umbraco/api/RIMSProducts/FamilyProductRegulations"
        : "/umbraco/api/RIMSProducts/ProductRegulations";
    config.getSingleItemUrl = isProductFamily
        ? "/umbraco/api/RIMSProducts/FamilyProductRegulation"
        : "/umbraco/api/RIMSProducts/ProductRegulation";
    config.pageTitle = "Linked Regulations";
    config.singleItemTitle = "Linked Regulation";
    config.entityType = "relation-products-compliance-regulations";
    config.entityTypeId = 14; // relation-products-compliance-regulations
    config.pageIcon = "fas fa-landmark";
    config.breadcrumbs = isProductFamily
        ? [{ "Name": "Product Families", "Link": "/your-medboard/product-families/" }]
        : [{ "Name": "Products", "Link": "/your-medboard/products/" }]
    config.dataStructure = [];
    config.exportUrl = isProductFamily
        ? `/umbraco/api/RIMSProducts/ProductRegulationsExport/?productFamilyId=${productFamilyId}&ids=`
        : `/umbraco/api/RIMSProducts/ProductRegulationsExport/?productId=${productId}&ids=`;
    config.hideAddButton = true;
    config.hideBreadcrumbs = true;
    config.showTitleAsSubTitle = !!showTitleAsSubTitle;
    config.enableCustomFields = true;
    config.showExportButton = true;
    config.showDeleteButton = false;
    config.showLegalManufacturerFilter = false;
    config.currentLegalManufacturerFilter = window.legalManufacturerId;
    config.currentLegalManufacturerNameFilter = window.legalManufacturerName;
    config.preLoadItemUrlParamName = "RelationshipId";
    config.excelExportFileName = "MedBoardLinkedRegulationsExport";
    config.customItemIdColumn = "RelationshipId"; // Column from the list that is used to do the get single


    let defaultFilters = isProductFamily
        ? [{ key: "ProductFamilyId", value: productFamilyId }]
        : [{ key: "ProductId", value: productId }];

    useEffect(() => {

        loadStructure();

    }, []);


    const loadStructure = () => {

        setIsLoadingStructure(true);
        setErrorLoadingStructure(false);

        let tableHeaderUrl = "/umbraco/api/CustomFields/Headers/?entityType=" + config.entityTypeId;

        let requestOptions = {
            method: 'GET',
        };

        fetch(tableHeaderUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                result.map(column => {
                    config.dataStructure.push({
                        customFieldId: column.CustomFieldId,
                        customFieldType: column.CustomFieldType,
                        name: column.Name,
                        field: column.Field,
                        width: column.Width,
                        sortable: column.Sortable,
                        isSelectItemCheckbox: column.IsSelectItemCheckbox,
                        renderWith: FieldTypes[column.RenderWith] ?? FieldTypes.FieldType_Text,
                        isMultiField: column.IsMultiField,
                        disableRowClick: column.DisableRowClick,
                    });
                });

                setDataTableStructure(config);
                setIsLoadingStructure(false);
            })
            .catch((error) => {
                setErrorLoadingStructure(true);
            })
            .finally(() => {
            });
    }

    
    return (<>

        {errorLoadingStructure ? <>
            <Error message={"Failed to load table configuration"} />
        </> : <>
                {isLoadingStructure ? <>
                    <LoadingSpinnerImage />
                </> : <>
                        <DataTable dataTableStructure={dataTableStructure} ItemDetailsPane={ItemDetailsPane} ReloadStructureFunction={loadStructure} defaultFilters={defaultFilters} />
                </>}

        </>}


    </>);

};






export default RelationProductsComplianceRegulations;